const SETTING = {
  prod: {
    apiUrl: 'apis.boyplaymj.link/',
    firebaseConfig: {
      apiKey: 'AIzaSyBpOo4gKdiueIBsqFwg69cK0N-v0xNqfYA',
      authDomain: 'sml-game.firebaseapp.com',
      databaseURL: 'https://sml-game-default-rtdb.firebaseio.com',
      projectId: 'sml-game',
      storageBucket: 'sml-game.appspot.com',
      messagingSenderId: '950607103327',
      appId: '1:950607103327:web:53f9d672f8b83d86b2a2ea',
      measurementId: 'G-2WP3LY8X41'
    }
  },
  test: {
    apiUrl: 'apis.boyplaymj.link/',
    // firebaseConfig: {
    //     apiKey: "AIzaSyBpOo4gKdiueIBsqFwg69cK0N-v0xNqfYA",
    //     authDomain: "sml-game.firebaseapp.com",
    //     databaseURL: "https://sml-game-default-rtdb.firebaseio.com",
    //     projectId: "sml-game",
    //     storageBucket: "sml-game.appspot.com",
    //     messagingSenderId: "950607103327",
    //     appId: "1:950607103327:web:53f9d672f8b83d86b2a2ea",
    //     measurementId: "G-2WP3LY8X41"
    // }
    firebaseConfig: {
      apiKey: 'AIzaSyATPypr1tgyKnG-8-J-Tn-Er8JKmKJSB7I',
      authDomain: 'boyplaymj-daily.firebaseapp.com',
      databaseURL: 'https://boyplaymj-daily-default-rtdb.firebaseio.com',
      projectId: 'boyplaymj-daily',
      storageBucket: 'boyplaymj-daily.appspot.com',
      messagingSenderId: '397030678993',
      appId: '1:397030678993:web:2c1feaab999225039e00f0',
      measurementId: 'G-WWHYE539RC'
    }
  },
  stage: {
    apiUrl: 'https://apis.boyplaymj.link/',
    // apiUrl: 'https://apis-dev.boyplaymj.link/',
    firebaseConfig: {
      apiKey: 'AIzaSyATPypr1tgyKnG-8-J-Tn-Er8JKmKJSB7I',
      authDomain: 'boyplaymj-daily.firebaseapp.com',
      databaseURL: 'https://boyplaymj-daily-default-rtdb.firebaseio.com',
      projectId: 'boyplaymj-daily',
      storageBucket: 'boyplaymj-daily.appspot.com',
      messagingSenderId: '397030678993',
      appId: '1:397030678993:web:2c1feaab999225039e00f0',
      measurementId: 'G-WWHYE539RC'
    }
  },
  version: '1.0.0',
  thousandSeparator: true,
  playoffYear: 2021,
  playoffMonth: 1,
  playoffDate: 22,
  decPlaces: 0,
  decimal: 0,
  colorList: [
    'rgba(239,127,34,1)',
    'rgba(28,141,192,1)',
    'rgba(244,34,224,1)',
    'rgba(114,45,224,1)',
    'rgba(242,12,35,1)',
    'rgba(0,158,66,1)',
    'rgba(188,117,0,1)',
    'rgba(179,181,182,1)',
    'rgba(250, 250, 250,1)',
    'rgba(34, 34, 34,1)'
  ],
  playerKey: [ // Ctrl+Shift
    { id: 212, key: 'A', name: '哈娜' },
    { id: 213, key: 'B', name: '耘耘' },
    { id: 214, key: 'C', name: '子齊' },
    { id: 215, key: 'D', name: '賢賢' },
    { id: 216, key: 'E', name: '綺綺' },
    { id: 217, key: 'F', name: '湘湘' },
    { id: 218, key: 'G', name: '蕭告' },
    { id: 219, key: 'H', name: '朵瑞斯' },
    { id: 220, key: 'I', name: '家聲' },
    { id: 221, key: 'J', name: '田亞霍' },
    { id: 222, key: 'K', name: '賊恩' },
    { id: 223, key: 'L', name: '令兒' },
    { id: 224, key: 'M', name: '宜臻' },
    { id: 225, key: 'S', name: '杯尼' },
    { id: 226, key: 'O', name: '李泥' },
    { id: 227, key: 'P', name: '李晟' }
  ],
  teamKey: [ // Alt+Shift
    { id: 139, key: 'A', name: '三途' },
    { id: 140, key: 'B', name: '佐賀' },
    { id: 141, key: 'C', name: '命運' },
    { id: 142, key: 'D', name: '帝皇' },
    { id: 143, key: 'E', name: '星辰' },
    { id: 144, key: 'I', name: '異度' },
    { id: 145, key: 'J', name: '雀丘' },
    { id: 146, key: 'H', name: '櫻滿' }
  ]
}
module.exports = SETTING
